import type {Appareil} from "@mytour/shared";
import {NATURE_INTERVENTION_OPTIONS} from "@mytour/shared";
import type {Control, FieldErrors} from "react-hook-form";
import {Controller} from "react-hook-form";
import {FormGroup, Input, Label} from "reactstrap";
import {z} from "zod";

export const interventionSchema = z.object({
  natureIntervention: z.array(z.string()).min(1, "Au moins une nature d'intervention"),
});

export type InterventionFormData = z.infer<typeof interventionSchema>;

type Props = {
  control: Control<InterventionFormData>;
  errors: FieldErrors<InterventionFormData>;
  disabled: boolean;
};

export function InterventionForm({control, errors, disabled}: Props) {
  return (
    <>
      <h5 style={{marginBottom: "16px"}}>Nature de l&apos;intervention</h5>
      {errors.natureIntervention && (
        <span style={{color: "red", fontSize: "12px"}}>{errors.natureIntervention.message}</span>
      )}
      <Controller
        name="natureIntervention"
        control={control}
        render={({field}) => (
          <>
            {NATURE_INTERVENTION_OPTIONS.map((option) => (
              <FormGroup check key={option}>
                <Input
                  type="checkbox"
                  id={`field-nature-${option}`}
                  checked={field.value.includes(option)}
                  onChange={(e) => {
                    if (e.target.checked) {
                      field.onChange([...field.value, option]);
                    } else {
                      field.onChange(field.value.filter((v: string) => v !== option));
                    }
                  }}
                  disabled={disabled}
                />
                <Label check for={`field-nature-${option}`}>
                  {option}
                </Label>
              </FormGroup>
            ))}
          </>
        )}
      />
    </>
  );
}

export function getInterventionDefaultValues(appareil: Appareil): InterventionFormData {
  return {natureIntervention: appareil.natureIntervention};
}
